import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  Paper,
  Table,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  IconButton,
  withStyles,
  Checkbox,
  Button,
  FormControlLabel,
} from '@material-ui/core'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import WmDispatchEmployeeItem from './WmDispatchEmployeeItem'

// utils
import { hasAccess } from '../../utils/api'
import SearchField from '../common/SearchField'
import AddEmployeeModal from './AddEmployeeModal'

const WmDispatchEmployeeItemEditable = EditableHOCWrapper(WmDispatchEmployeeItem)
const styles = (theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
})

class WmDispatchShopInfoEmployees extends Component {
  constructor(props) {
    super(props)
    this.state = {
      term: '',
      checked: false,
      page: 0,
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50, 100],
      modalSyncMembers: false,
      dchEmployeesSearch: [],
    }
  }

  componentDidMount() {
    this.setState()
    this.filter('')
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dchEmployees !== this.props.dchEmployees) {
      this.filter('')
    }
  }

  removeWorkerFromList = (data) => {
    this.props.removeWorkerFromList(data)
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  onSearch = (e) => {
    if (e === '' || /^( )*$/.test(e)) {
      this.filter('')
    } else {
      this.filter(e)
    }
  }

  filter(value) {
    const { dchEmployees = [] } = this.props
    let newList = []
    if (value === '') {
      newList = dchEmployees
    } else {
      newList = dchEmployees.filter((s) =>
        (s.firstName ? s.firstName : '')
          .concat(' ')
          .concat(s.lastName ? s.lastName : '')
          .toLowerCase()
          .includes(value.toLowerCase()),
      )
    }
    this.setState({
      dchEmployeesSearch: newList,
    })
  }

  handleChange = (e) => {
    this.setState({ checked: e.target.checked })
  }

  addEmployee = () => {
    this.setState({
      modalSyncMembers: true,
    })
  }

  startSync = (employeeIds) => {
    const { shopId } = this.props
    const { employeeList = [], dchEmployees = [] } = this.props

    employeeIds.forEach((id) => {
      let exist = dchEmployees.find((d) => d.employeeId === id)
      if (!exist) {
        // create driver in ms dispatch
        // and update the dchEmployees list here
        let data = employeeList.find((e) => e.id === id)
        data.shopId = shopId
        this.props.createNewInternalWorker(data, (res) => {
          if (res.id) {
            dchEmployees.push(res)
            this.handleCloseModalSync()
          }
        })
      }
    })
  }

  handleCloseModalSync = () => {
    this.setState({
      modalSyncMembers: false,
    })
  }

  render() {
    const {
      page,
      rowsPerPage,
      rowsPerPageOptions,
      modalSyncMembers = false,
      dchEmployeesSearch = [],
    } = this.state
    const {
      employeeList = [],
      shopsList = [],
      shopInfo,
      getWorkers = () => {},
      createNewWorker = () => {},
      linkWorker = () => {},
      removeWorker = () => {},
      dchCompanyEmployees = [],
      deleteEmployee = () => {},
    } = this.props

    const dchEmployeesfilter = dchEmployeesSearch.filter(
      (employee) =>
        (employee.externalEmployeeIds &&
          employee.externalEmployeeIds.filter((e) => e.provider === 'WMDISPATCH' && !e.deleted)
            .length > 0) ||
        (employee.editMode != undefined && employee.editMode),
    )

    const employeesListfilter = employeeList.filter((e) => {
      let exits = dchCompanyEmployees.find((d) => !d.deleted && d.employeeId === e.id)
      if (exits === undefined) {
        return e
      }
      return null
    })

    return (
      <div>
        <Typography variant="title">{(shopInfo && shopInfo.name) || ''}</Typography>
        <Grid container className="margin-top-medium remove-margin">
          <Grid item xs={12} sm={4}>
            <div className="category-rightside">
              <SearchField
                onSearch={this.onSearch}
                onChange={this.onChangeTerm}
                value={this.state.term}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              className="field-check"
              control={<Checkbox checked={this.state.checked} onChange={this.handleChange} />}
              label="Show Linked Employees"
            />
          </Grid>
          <Grid item xs={12} sm={2} style={{ paddingRight: 3 }}>
            <Button
              variant="outlined"
              color="primary"
              className="b-outline"
              onClick={this.addEmployee}
              fullWidth
            >
              <span className="button-text">Add Employee</span>
            </Button>
          </Grid>
        </Grid>
        <Grid container className="full-width">
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="margin-top-small" elevation={1}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Employee</TableCell>
                    <TableCell>WM Dispatch ID</TableCell>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(!this.state.checked ? dchEmployeesSearch : dchEmployeesfilter)
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(
                      (employee) =>
                        employee && (
                          <WmDispatchEmployeeItemEditable
                            key={employee.id}
                            dataToEdit={employee}
                            defaultEditMode={employee.editMode}
                            getWorkers={getWorkers}
                            createNewWorker={createNewWorker}
                            linkWorker={linkWorker}
                            removeWorker={removeWorker}
                            deleteEmployee={deleteEmployee}
                          />
                        ),
                    )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      colSpan={3}
                      count={
                        !this.state.checked ? dchEmployeesSearch.length : dchEmployeesfilter.length
                      }
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActionsWrapped}
                      rowsPerPageOptions={rowsPerPageOptions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Paper>
          </Grid>

          {modalSyncMembers && (
            <AddEmployeeModal
              open={modalSyncMembers}
              employeesList={employeesListfilter}
              startSync={this.startSync}
              close={this.handleCloseModalSync}
            />
          )}
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(WmDispatchShopInfoEmployees)

/* ------ PAGINATION ------ */
const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
})

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0)
  }

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1)
  }

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1)
  }

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
    )
  }

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
  TablePaginationActions,
)



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchShopInfoEmployees.js